module.exports = "./img/899afd0068dcd8ce4da10e2f66e179b3.jpg";